const handleStickyHeader = () => {
	const $trigger = $('.js-sticky-header');
	const $window = $(window);

	if ($trigger.length === 0) {
		return;
	}

	$window.on('load scroll', function() {
		const isSticky = $window.scrollTop() > 0;

		$trigger.toggleClass('header--sticky', isSticky);
	});
}

handleStickyHeader();
